<template lang="html">

  <VqModal
    :name="modalName"
    class="vq-modal-add-pool">
    <template v-slot:header>
      <h2 class="modal-title">{{setTitleContext}} <span class="is-bold">{{ $t('components.modalEditRole.role') }}</span></h2>

      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>

    <template v-slot:content>
      <div class="forms">
        <form>
          <div class="container has-separator">
            <div class="row">
              <VqInput
                classes="col-tab-8 pb-5"
                :label="$t('components.modalEditRole.form.name')"
                name="name"
                type="text"
                :errors="errors.name"
                v-model="formData.name"
              />
            </div>
          </div>

          <div class="container row">

            <VqToggleBtn
              classes="col-tab-6"
              name="opening_general_ticket"
              :label="$t('roles.permissions.opening_general_ticket')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.opening_general_ticket"
            />

            <VqToggleBtn
              v-if="hasSignedAdditionalContract && hasDirectorAccess"
              classes="col-tab-6"
              name="opening_pool_create_ticket"
              :label="$t('roles.permissions.opening_pool_create_ticket')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.opening_pool_create_ticket"
            />

            <VqToggleBtn
              v-if="hasSignedAdditionalContract && hasDirectorAccess"
              classes="col-tab-6"
              name="opening_pool_update_ticket"
              :label="$t('roles.permissions.opening_pool_update_ticket')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.opening_pool_update_ticket"
            />

            <VqToggleBtn
              v-if="hasSignedAdditionalContract && hasAgilityAccess"
              classes="col-tab-6"
              name="opening_vm_creation_ticket"
             :label="$t('roles.permissions.opening_vm_creation_ticket')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.opening_vm_creation_ticket"
            />

            <VqToggleBtn
              v-if="hasSignedAdditionalContract && hasAgilityAccess"
              classes="col-tab-6"
              name="opening_vm_delete_ticket"
              :label="$t('roles.permissions.opening_vm_delete_ticket')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.opening_vm_delete_ticket"
            />
            <VqToggleBtn
              v-if="hasSignedAdditionalContract && hasAgilityAccess"
              classes="col-tab-6"
              name="opening_vm_update_ticket"
              :label="$t('roles.permissions.opening_vm_update_ticket')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.opening_vm_update_ticket"
            />

            <VqToggleBtn
              v-if="hasAgilityAccess"
              classes="col-tab-6"
              name="viewing_agility_pages"
              :label="$t('roles.permissions.viewing_agility_pages')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.viewing_agility_pages"
            />
        
            <VqToggleBtn
              v-if="hasBackupAccess"
              classes="col-tab-6"
              name="viewing_backups_activity"
              :label="$t('roles.permissions.viewing_backups_activity')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.viewing_backups_activity"
            />

            <VqToggleBtn
              v-if="hasBackupAccess"
              classes="col-tab-6"
              name="viewing_backups_devices"
              :label="$t('roles.permissions.viewing_backups_devices')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.viewing_backups_devices"
            />
        
            <VqToggleBtn
              v-if="hasBackupAccess"
              classes="col-tab-6"
              name="viewing_backups_veeam"
              :label="$t('roles.permissions.viewing_backups_veeam')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.viewing_backups_veeam"
            />
      
            <VqToggleBtn
              v-if="hasDirectorAccess"
              classes="col-tab-6"
              name="viewing_director_pages"
              :label="$t('roles.permissions.viewing_director_pages')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.viewing_director_pages"
            />

            <VqToggleBtn
              classes="col-tab-6"
              name="viewing_invoices"
              :label="$t('roles.permissions.viewing_invoices')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.viewing_invoices"
            />
          
            <VqToggleBtn
              classes="col-tab-6"
              name="action_on_vm"
              :label="$t('roles.permissions.action_on_vm')"
              :option-true="$t('components.modalEditRole.form.on')"
              :option-false="$t('components.modalEditRole.form.off')"
              v-model="formData.action_on_vm"
            />
          </div>
        </form>
      </div>
    </template>
    <template v-if="context=='update'" v-slot:footer>
      <button v-if='display_edit' type="button" class="button is-small is-danger is-outline" v-on:click="deleteRole">{{ $t('components.modalEditRole.form.delete') }}</button>
      <div>
        <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalEditRole.form.cancel') }}</button>
        <button
          v-if='display_edit'
          :class="{'is-loading': isFormLoading}"
          type="button"
          class="button is-small is-gamma"
          @click="createRole">{{setTitleContext}} {{ $t('components.modalEditRole.role') }}</button>
      </div>
    </template>
    
    <template v-else v-slot:footer>
      <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalEditRole.form.cancel') }}</button>
      <div>
        <button
          v-if='display_edit'
          :class="{'is-loading': isFormLoading}"
          type="button"
          class="button is-small is-gamma"
          @click="createRole">{{setTitleContext}} {{ $t('components.modalEditRole.role') }}</button>
      </div>
    </template>
  </VqModal>
</template>

<script lang="js">
import { mapGetters } from 'vuex'

import { eventHubMixin } from '@/mixins/event'

import ROLE from '@/api/roles'

import VqModal from '@/components/VqModal.vue'
import VqInput from '@/components/VqInput.vue'
import VqToggleBtn from '@/components/VqToggleBtn.vue'

export default {
  name: 'ModalAddEditRole',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqInput,
    // VqRadio,
    VqToggleBtn
  },
  data() {
    return {
      display_edit: true,
      modalName: 'add-edit-role',
      formData: {},
      errors: {},
      context: 'add',
      isFormLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      hasSignedAdditionalContract: 'auth/hasSignedAdditionalContract',
      hasAgilityAccess: 'auth/hasAgilityAccess',
      hasBackupAccess: 'auth/hasBackupAccess',
      hasDirectorAccess: 'auth/hasDirectorAccess',
    }),
    setTitleContext() {
      if (this.context === 'add') {
        return this.$t('components.modalEditRole.config.add')
      }
      if (this.context === 'update') {
        return this.$t('components.modalEditRole.config.edit')
      }
      return this.$t('components.modalEditRole.config.edit')
    },
  },
  mounted() {
    this.display_edit = this.$store.state.display_edit
    this.eventHub.$on(`modal:${this.modalName}:open`, (data) => {
      this.initFormData()
      this.initFormErrors()
      if (data) {
        this.context = 'update'
        Object.assign(this.formData, data)
      } else {
        this.context = 'add'
      }
    })
  },
  methods: {

    close() {
      this.eventHub.$emit(`modal:${this.modalName}:close`)
    },

    initFormData() {
      this.formData = {
        name: '',
        viewing_backups_activity: false,
        viewing_backups_devices: false,
        viewing_backups_veeam: false,
        viewing_invoices: false,
        viewing_agility_pages: false,
        viewing_director_pages: false,
        opening_vm_creation_ticket: false,
        opening_vm_update_ticket: false,
        opening_vm_delete_ticket: false,
        opening_pool_create_ticket: false,
        opening_pool_update_ticket: false,
        opening_general_ticket: false,
        action_on_vm: false,
        verbose_permissions: "",
      }
    },

    initFormErrors() {
      this.errors = {
        name: [],
      }
    },


    emitToaster(title, text, state) {
      this.emitAddToaster({
        title,
        text,
        state,
      })
    },

    performSuccessAction(event, data) {
      this.isFormLoading = false
      this.$emit(event, data)
      this.initFormData()
      this.initFormErrors()
      this.close()
    },

    createRole() {
      this.isFormLoading = true
      if (this.context === 'add') {
        ROLE.create(this.formData).then((res) => {
          this.performSuccessAction('createrole', res.data)
          this.emitToaster(this.$t('components.modalEditRole.toasts.success'), `${this.$t('components.modalEditRole.role')} ${this.formData.name} ${this.$t('components.modalEditRole.toasts.edited')}`, 'success')
        },
          (err) => {
            if (err.response.data.errors) {
              this.emitToaster(this.$t('components.modalEditRole.toasts.createFailed'), `${this.$t('components.modalEditRole.role')} ${this.formData.name} ${this.$t('components.modalEditRole.toasts.createFailedContent')} ${err.response.data.errors}`, 'danger')
              this.close()
            }
            this.isFormLoading = false
            Object.assign(this.errors, err.response.data)
          },
        )
      } else {
        ROLE.update(this.formData.id, this.formData).then((res) => {
          this.performSuccessAction('editrole', res.data)
          this.emitToaster(this.$t('components.modalEditRole.toasts.success'), `${this.$t('components.modalEditRole.role')} ${this.formData.name} ${this.$t('components.modalEditRole.toasts.edited')}`, 'success')
          },
          (err) => {
            if (err.response.data.errors) {
              this.emitToaster(this.$t('components.modalEditRole.toasts.editFailed'), `${this.$t('components.modalEditRole.role')} ${this.formData.name} ${this.$t('components.modalEditRole.toasts.editFailedContent')} ${err.response.data.errors}`, 'danger')
              this.close()
            }
            this.isFormLoading = false
            Object.assign(this.errors, err.response.data)
          },
        )
      }
    },

    deleteRole() {
      this.eventHub.$emit('modal:delete-role:open', this.formData)
      this.close()
    },
  },
}
</script>
